module.exports = __webpack_public_path__ + "img/earth.6a60d133.png";